import { APIEntityType, ArdoqId } from '@ardoq/api-types';
import { OtherLabelsData } from './types';
import { getRelevantLabelFormatting } from './otherLabelUtils';
import { labelFormattingLabels } from './labelFormattingLabels';
import { LabelsInterface } from '../labelsInterface/labelsInterface';
import { newConditionalFormattingMultiLabelStyle } from './multiLabelStyles';
import { type I18nLocale } from '@ardoq/i18n';

export const getOtherLabelsDataForComponent = (
  labelsInterface: LabelsInterface,
  componentId: ArdoqId
): OtherLabelsData | null => {
  const labelFormatting = labelsInterface.getLabelFormattingRules();
  const workspaceId = labelsInterface.getComponentWorkspaceId(componentId);
  const componentTypeName = labelsInterface.getComponentTypeName(componentId);

  if (
    !workspaceId ||
    !componentTypeName ||
    !labelsInterface.getWorkspaceModelId(workspaceId)
  ) {
    return null;
  }

  const fields = labelsInterface.getComponentFields(componentId);

  return {
    entityId: componentId,
    fields,
    labelFormatting,
    entityTypeName: componentTypeName,
  };
};

export const getOtherLabelsForComponent = (
  labelsInterface: LabelsInterface,
  modelId: ArdoqId,
  i18nLocale: I18nLocale
) => {
  const labelsData = getOtherLabelsDataForComponent(labelsInterface, modelId);

  if (!labelsData) {
    return;
  }

  const relevantFormatting =
    getRelevantLabelFormatting({
      apiEntityType: APIEntityType.COMPONENT,
      ...labelsData,
    }) ?? undefined;

  // TODO: style should be evaluated based on conditional formatting when we pick up the multi-label coloring
  const multiLabelStyle = newConditionalFormattingMultiLabelStyle;

  return (
    relevantFormatting &&
    relevantFormatting.flatMap(
      labelFormattingLabels({
        labelsInterface,
        modelId,
        entityFields: labelsData.fields,
        entityType: APIEntityType.COMPONENT,
        multiLabelStyle,
        i18nLocale,
      })
    )
  );
};
